import { cn } from "~/lib/utils";

import {
  PortalTooltip,
  PortalTooltipContent,
  PortalTooltipProvider,
  PortalTooltipTrigger,
} from "./portal-tooltip";

interface Props {
  className?: string;
  title: string;
  label?: string;
  align?: "start" | "center" | "end";
  side?: "top" | "right" | "bottom" | "left";
  lines?: number;
}

export const ToolTipEllipsis = ({
  className,
  label,
  title,
  align,
  side,
  lines = 1,
}: Props) => {
  return (
    <PortalTooltipProvider>
      <PortalTooltip>
        <PortalTooltipTrigger asChild>
          <span
            className={cn(
              "inline-block overflow-hidden capitalize",
              lines === 1
                ? "max-w-[10ch] text-ellipsis whitespace-nowrap"
                : `line-clamp-${lines}`,
              className,
            )}
          >
            {label || title}
          </span>
        </PortalTooltipTrigger>
        <PortalTooltipContent
          align={align}
          side={side}
          className="max-w-[300px] text-wrap break-words"
        >
          {title}
        </PortalTooltipContent>
      </PortalTooltip>
    </PortalTooltipProvider>
  );
};
